import { api } from '@/lib/api';

// ─── Types ──────────────────────────────────────────

export type MigrationAction = 'enrich_existing' | 'create_document' | 'create_database';

export interface MigrationBlockDestination {
  databaseId?: string;
  databaseName?: string;
  documentId?: string;
  documentName?: string;
}

export interface MigrationBlock {
  id: string;
  promptExcerpt: string;
  startLine: number;
  endLine: number;
  topic: string;
  action: MigrationAction;
  destination: MigrationBlockDestination;
  contentToAdd: string;
  reason: string;
}

export interface AnalyzePromptResponse {
  blocks: MigrationBlock[];
  originalTokenCount: number;
  estimatedTokenCountAfter: number;
}

export type ExecutedAction = 'enriched' | 'document_created' | 'database_created';

export interface ExecuteMigrationResponse {
  updatedPrompt: string;
  action: ExecutedAction;
  destination: {
    databaseId: string;
    databaseName: string;
    documentId: string;
    documentName: string;
  };
}

// ─── API ────────────────────────────────────────────

export const promptMigrationApi = {
  async analyzePrompt(
    agentId: string,
    systemPrompt: string,
    databaseIds: string[],
  ): Promise<AnalyzePromptResponse> {
    const response = await api.post(`agent-training/${agentId}/analyze-prompt`, {
      systemPrompt,
      databaseIds,
    });
    return response.data.data;
  },

  async executeMigration(
    agentId: string,
    block: MigrationBlock,
    currentPrompt: string,
  ): Promise<ExecuteMigrationResponse> {
    const response = await api.post(`agent-training/${agentId}/execute-migration`, {
      block,
      currentPrompt,
    });
    return response.data.data;
  },

  /**
   * Refinador de estrutura — reescreve o prompt em tags XML do catálogo
   * mantendo 100% do conteúdo substantivo. Chamado pelo wizard de
   * Otimizar Prompt no step final, depois da migração pra base.
   * Backend usa o mesmo `PromptRewriterService` do Coach Apply Diff.
   */
  async refinePromptStructure(
    agentId: string,
    currentPrompt: string,
  ): Promise<{ newSystemPrompt: string; changeSummary: string }> {
    const response = await api.post(
      `agent-training/${agentId}/refine-prompt-structure`,
      { currentPrompt },
    );
    return response.data.data;
  },
};
